// extracted by mini-css-extract-plugin
export default {"graphic":"Graphic_graphic__o9p+P","fitToSize":"Graphic_fitToSize__F5TmS","wrapper":"Graphic_wrapper__F0I+1","selected":"Graphic_selected__N2Tzw"};